module.exports = __webpack_public_path__ + "img/layout_vertical_right.061306cb.svg";